/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils/A11y';
import {
  Ta11yText,
  ButtonPrimary,
  CardSupport,
  ScrollToTop,
  ButtonCancelActivation
} from '@core/index';
import { TariffProduct } from '@part/Tariff';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { appButtonType, appIconsPath } from '@utils/globalConstant';

export function SingleTariff() {
  // Contexts
  const {
    isLoading,
    bookableTariffs,
    setTariffActivationForm,
    setStep2SubStep,
    bookableTariffsEtcOne
  } = useActivation();
  const { tA11yTranslate } = useA11y();

  // Functions
  function onTariffClicked() {
    const {
      id,
      name,
      nameSpeed = '',
      currentPrice = '',
      additionalInfo: { primaryColor }
    } = bookableTariffs[0];

    const { price: currentAmount = 0 } =
      bookableTariffsEtcOne.find((tariff) => tariff.id === id) || {};

    setTariffActivationForm({
      chosenTariffId: id,
      chosenTariffName: name,
      chosenTariffSpeed: nameSpeed,
      tariffColor: primaryColor,
      tariffPrice: currentPrice,
      tariffAmount: currentAmount,
      tariffAmountAsStr: currentAmount.toString()
    });
    setStep2SubStep(1);
  }

  return (
    <>
      <ScrollToTop>
        <div className="min-dvh-100">
          <AppPageContentWrapper>
            <div className="row justify-content-center">
              <Ta11yText
                tag="h2"
                textContent={tA11yTranslate('ek_reg_tariff_hdl1')}
                className="text-primary m-0"
              />
              <div className="col-12 d-flex justify-content-center my-40">
                <TariffProduct tariff={bookableTariffs[0]} isActiveCard />
              </div>
              <div className="col-lg-8 col-10 px-0 mx-auto">
                <ButtonPrimary
                  buttonClass="mb-40"
                  buttonType={appButtonType.PRIMARY}
                  buttonContent={tA11yTranslate('ek_reg_tariff_btn1')}
                  isLoading={isLoading}
                  iconRight={appIconsPath.ARROW_RIGHT}
                  onClick={() => onTariffClicked()}
                />
              </div>
              <CardSupport />
              <div className="d-flex justify-content-center mt-32">
                <ButtonCancelActivation />
              </div>
            </div>
          </AppPageContentWrapper>
        </div>
      </ScrollToTop>
    </>
  );
}

export default SingleTariff;
